<template>
  <div class="connect">
    <div style="height: 100px;"></div>
    <div style="display: flex;">
      <div style="width: 50%;padding: 40px;">
        <div style="font-size: 26px;color: white;margin-bottom: 30px;margin-top: 20px;">联系我们</div>
        <el-form>
          <el-form-item label="姓名" required>
            <el-input v-model="form.name" placeholder="姓名" />
          </el-form-item>
          <el-form-item label="邮箱" required>
            <el-input v-model="form.email" placeholder="邮箱" />
          </el-form-item>
          <el-form-item label="备注" required>
            <el-input v-model="form.memo" placeholder="备注" type="textarea" :rows="8" />
          </el-form-item>
          <el-form-item>
            <el-button style="float: right;" type="primary" @click="submit">提 交</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div style="width: 50%;padding: 40px;">
        <baidu-map :center="center" :zoom="zoom" @ready="handler" style="height:600px" @click="getClickInfo" :scroll-wheel-zoom='true'>
        </baidu-map>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'
import {Message} from "element-ui";

export default {
  name: 'Connect',
  data() {
    return {
      center: { lng: 109.45744048529967, lat: 36.49771311230842 },
      zoom: 13,
      form: {
        name: '',
        email: '',
        memo: ''
      }
    }
  },
  mounted() {
    // eslint-disable-next-line no-undef
    // var map = new BMapGL.Map("container")
  },
  methods: {
    handler({ BMap, map }) {
      let point = new BMap.Point(121.457531, 31.254054)
      map.centerAndZoom(point, 13)
      let marker = new BMap.Marker(point) // 创建标注
      map.addOverlay(marker) // 将标注添加到地图中
      let circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
      map.addOverlay(circle)
    },
    getClickInfo(e) {
      console.log(e.point.lng)
      console.log(e.point.lat)
      this.center.lng = e.point.lng
      this.center.lat = e.point.lat
    },
    submit() {
      const phonereg = /^[1][2,3,4,5,6,7,8,9][0-9]{9}$/
      const mailreg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/
      if (!this.form.name) {
        Message.error('请输入姓名')
        return
      }
      if (!this.form.memo) {
        Message.error('请输入备注')
        return
      }
      if (!mailreg.test(this.form.email)) {
        Message.error('请输入合法电子邮箱')
        return
      }
      axios.post('https://api.deercal.com' + '/api/common/appointments/notice', {
        channel: 2,
        expand_params: {
          memo: this.memo
        },
        email: this.form.email,
        name: this.form.name
      }).then(res => {
        this.$message.success('提交成功')
      }).catch(() => {
        this.$message.error('提交失败，请联系客服！')
      })
    },

    // submit() {
    //   if (!this.form.name || !this.form.email || !this.form.memo) {
    //     this.$message.error('请输入必填项')
    //     return
    //   }
    //   axios.put('https://api.deercal.com/api/common/appointments/call_us', this.form).then(res => {
    //     console.log(res)
    //     if (res.status === 200 || res.status === 201) {
    //       if (res.data.code === 0 || res.data.code === '0') {
    //         this.$message.success('提交成功')
    //         return
    //       }
    //       this.$message.error(res.data.msg)
    //       return
    //     }
    //     this.$message.error('提交失败，请联系客服！')
    //   }).catch(e => {
    //     this.$message.error('提交失败，请联系客服！')
    //   })
    // }
  }
}
</script>

<style scoped>
#container{
  width: 500px;
  height: 500px;
}
  .connect{
    background: url("../../assets/2019-02-MEGI-HOME-webpage-Illustration-02.png") no-repeat;
    background-size: 100% 100%;
  }

</style>
<style>
  .connect .el-form-item__label{
    color: white;
  }
</style>
